import { useEffect } from "react"

import useFetch from "shared/model/useFetch"

const useGetAdList = () => {
    const [fetchResult, fetchRequest] = useFetch()

    useEffect(() => {
        fetchRequest("GET", `/column/ad/list`)
    }, [])

    return [fetchResult]
}

export default useGetAdList